const madmaxPath = "framework/";
const gamePath = "";

const gameset = {
    stageWidth: 1280,
    stageHeight: 720,
    loadGraphics: "c",
    preferGraphics: "h",
    amaTitle: "Vikings Dice",
    gameName: "Vikings Dice",
    mute: false,
    gameType: "reel",
    currency: "cents",
    game_id: "vikings_dice",
    casino_id: 0,
    uxtype: "mobile",
    gameSign: "Vikings Dice",
    version: "h",
    language: "en",
    lineGameType: "normal", //"normal", "lines", "levels"

    preloader: {},
    scripts: [
        "framework/src/vendor/jquery.min.js",
        "framework/src/vendor/tween.js",
    ],
    system: {
        audio: {
            tracks: [
                {
                    name: 'Jackpot_sound',
                    url: `${gamePath}assets/JokerWinBanner/Jackpot_sound.{ogg,mp3}`,
                    classVol: 'volume.normalWin',
                    loop: false,
                },
                {
                    name: 'JokerBonus_alert',
                    url: `${gamePath}assets/JokerWinBanner/JokerBonus_alert.{ogg,mp3}`,
                    classVol: 'volume.normalWin',
                    loop: false,
                },
                {
                    name: "ui_Btn_Generic",
                    url: madmaxPath + "assets/audio/ui_Btn_Generic.{ogg,mp3}",
                    classVol: "volume.buttonEffect",
                },
                {
                    name: "ui_Btn_Up",
                    classVol: "volume.buttonEffect",
                    reference: "ui_Btn_Generic",
                },
                {
                    name: "ui_Btn_Down",
                    classVol: "volume.buttonEffect",
                    reference: "ui_Btn_Generic",
                },
                {
                    name: "ui_Counter",
                    url: `${madmaxPath}assets/audio/ui_Counter.{ogg,mp3}`,
                    classVol: "volume.winCounter",
                    loop: true,
                },
                {
                    name: "ui_Counter_Stop",
                    url: `${madmaxPath}assets/audio/ui_Counter_Stop.{ogg,mp3}`,
                    classVol: "volume.winCounter",
                },
                {
                    name: "button_click",
                    reference: "ui_Btn_Generic",
                },
                {
                    "name"  : "bg_Ambient",
                    "url"   : `${gamePath}assets/audio/bg_Ambient.{ogg,mp3}`,
                    "loop"  : true,//false,
                    "classVol": "background.background",
                },
                {
                    "name"  : "bg_Music",
                    "url"   : `${gamePath}assets/audio/bg_Music.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol": "background.background",
                },                     
                {
                    "name": "reel_Start_1",
                    "url": `${gamePath}assets/audio/reel_Start_1.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.startReel",
                },
                {
                    "name": "reel_Start_2",
                    "url": `${gamePath}assets/audio/reel_Start_2.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.startReel",
                },
                {
                    "name": "reel_Start_3",
                    "url": `${gamePath}assets/audio/reel_Start_3.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.startReel",
                },
                {
                    "name": "reel_Stop",
                    "url": `${gamePath}assets/audio/reel_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.stopReel",
                },                
                {
                    "name": "reel_Search_Short",
                    "url" : `${gamePath}assets/audio/reel_Search_Short.{ogg,mp3}`,
                    "loop": false,
                    "classVol" : "miscSounds.miscSounds1",
                },
                {
                    "name": "reel_Search_Long",
                    "url" : `${gamePath}assets/audio/reel_Search_Long.{ogg,mp3}`,
                    "loop": false,
                    "classVol" : "miscSounds.miscSounds1",
                },                
                {
                    "name": "symbol_Ship_1",
                    "url" : `${gamePath}assets/audio/symbol_Ship_1.{ogg,mp3}`,
                    "loop": false,
                    "classVol" : "miscSounds.miscSounds1",
                },
                {
                    "name": "symbol_Ship_2",
                    "url" : `${gamePath}assets/audio/symbol_Ship_2.{ogg,mp3}`,
                    "loop": false,
                    "classVol" : "miscSounds.miscSounds1",
                },
                {
                    "name": "symbol_Ship_3",
                    "url" : `${gamePath}assets/audio/symbol_Ship_3.{ogg,mp3}`,
                    "loop": false,
                    "classVol" : "miscSounds.miscSounds1",
                },                
                {
                    "name": "arrow1",
                    "url": `${gamePath}assets/audio/bonus_Arrow_1.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds2",//volume.winAnim",
                },
                {
                    "name": "arrow2",
                    "url": `${gamePath}assets/audio/bonus_Arrow_2.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds2",//volume.winAnim",
                },
                {
                    "name"  : "bonus_Lock_Fire",
                    "url"   : `${gamePath}assets/audio/bonus_Lock_Fire.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol": "miscSounds.miscSounds2",//miscSounds.miscSounds2",
                },
                {
                    "name"  : "bonus_FreeSpins_In",
                    "url"   : `${gamePath}assets/audio/bonus_FreeSpins_In.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol": "miscSounds.miscSounds4",//miscSounds.miscSounds2",
                },                
                {
                    "name"  : "bonus_FreeSpins_Counter",
                    "url"   : `${gamePath}assets/audio/bonus_FreeSpins_Counter.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol": "volume.winCounter",//miscSounds.miscSounds2",
                },                     
                {
                    "name"  : "bg_FreeSpins_Start",
                    "url"   : `${gamePath}assets/audio/bg_FreeSpins_Start.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol": "background.freeSpinsBackground",
                },
                {
                    "name"  : "bg_FreeSpins_Loop",
                    "url"   : `${gamePath}assets/audio/bg_FreeSpins_Loop.{ogg,mp3}`,
                    "loop"  :  true,
                    "classVol": "background.freeSpinsBackground",
                },
                {
                    "name"  : "bwin_FreeSpins",
                    "url"   : `${gamePath}assets/audio/bwin_FreeSpins.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.bigWin",
                },
                {
                    "name"  : "bwin_Money",
                    "url"   : `${gamePath}assets/audio/bwin_Money.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.bigWin",
                },
                {
                    "name"  : "bwin_BigWin_Counter",
                    "url"   : `${gamePath}assets/audio/bwin_BigWin_Counter.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.bigWin",
                },
                {
                    "name"  : "bwin_BigWin_Thunder",
                    "url"   : `${gamePath}assets/audio/bwin_BigWin_Thunder.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.bigWin",
                },
                {
                    "name"  : "bwin_BigWin",
                    "url"   : `${gamePath}assets/audio/bwin_BigWin.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.bigWin",
                },
                {
                    "name"  : "win_Letter",
                    "url"   : `${gamePath}assets/audio/win_Letter.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Bracelet",
                    "url"   : `${gamePath}assets/audio/win_Bracelet.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Shield",
                    "url"   : `${gamePath}assets/audio/win_Shield.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Axe",
                    "url"   : `${gamePath}assets/audio/win_Axe.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Helmet",
                    "url"   : `${gamePath}assets/audio/win_Helmet.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Woman",
                    "url"   : `${gamePath}assets/audio/win_Woman.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Viking",
                    "url"   : `${gamePath}assets/audio/win_Viking.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Scatter",
                    "url"   : `${gamePath}assets/audio/win_Ship.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Multiplier_Letter",
                    "url"   : `${gamePath}assets/audio/win_Multiplier_Letter.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Multiplier_Bracelet",
                    "url"   : `${gamePath}assets/audio/win_Multiplier_Bracelet.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Multiplier_Shield",
                    "url"   : `${gamePath}assets/audio/win_Multiplier_Shield.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Multiplier_Axe",
                    "url"   : `${gamePath}assets/audio/win_Multiplier_Axe.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Multiplier_Helmet",
                    "url"   : `${gamePath}assets/audio/win_Multiplier_Helmet.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Multiplier_Woman",
                    "url"   : `${gamePath}assets/audio/win_Multiplier_Woman.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "win_Multiplier_Viking",
                    "url"   : `${gamePath}assets/audio/win_Multiplier_Viking.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "volume.winAnim",
                },
                {
                    "name"  : "misc_Coin_Drop_1",
                    "url"   : `${gamePath}assets/audio/misc_Coin_Drop_1.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "miscSounds.miscSounds3",
                },
                {
                    "name"  : "misc_Coin_Drop_2",
                    "url"   : `${gamePath}assets/audio/misc_Coin_Drop_2.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "miscSounds.miscSounds3",
                },
                {
                    "name"  : "misc_Coin_Drop_3",
                    "url"   : `${gamePath}assets/audio/misc_Coin_Drop_3.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "miscSounds.miscSounds3",
                },
                {
                    "name"  : "misc_Coin_Drop_4",
                    "url"   : `${gamePath}assets/audio/misc_Coin_Drop_4.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "miscSounds.miscSounds3",
                },
                {
                    "name"  : "misc_Coin_Drop_5",
                    "url"   : `${gamePath}assets/audio/misc_Coin_Drop_5.{ogg,mp3}`,
                    "loop"  : false,
                    "classVol" : "miscSounds.miscSounds3",
                },

           ],
        },
    },
    game: {
        basic: {
            symbolsCount: 8,
            slotsRows: 3,
            slotsColumns: 5,
            pilarsCount: 5,
        },
        webfonts: [
            "winlines",
            "TeXGyrePagella",
            "UbuntuMono-Regular",
            "Audiowide-Regular",
        ],
        layers: [
            "background",
            "idleAnim",
            {
                name: "winLines",
                layers: ["normal", "idle"],
            },
            "reels",
            "black",
            "preloader",
            "dynamicText",

            "winLineNumbers",
            {
                name: "info",
                layers: [
                    "bg",
                    "pageOne",
                    "pageTwo",
                    "pageThree",
                    "pageFour",
                    "pageFive"
                ],
            },
            "foreground",
            "symbolAnimations",
            "touchZone",
            "winFactors",
            "emitter",
            "bigWin",
            "logo",
        ],
        subLayers: [],

        audio: {
            tracks: [
                /*                {
                    "name": "ui_Btn_WinFactors",
                    "url": `${gamePath}assets/audio/ui_Btn_WinFactors.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.buttonEffect"
                },
*/
            ],
            playlists: [],
        },
        fonts: {
            fontFamilies: [
                // {
                //     "name": "winlines_circle_on-export",
                //     "type": "bitmap"
                // }
            ],
            defaultFamily: "winlines_circle_off-export",
            fontSet: [
                // {
                //     "name": "winlines_circle_on-export",
                //     "family": "winlines_circle_on-export",
                //     "align": "center",
                //     "fontSize": 80,
                //     "anchor": [0.5, 0.5],
                //     "fontFamily": "winlines_circle_on-export",
                //     "isDefault": false
                // }
            ],
        },

        symbolModel: {
            enabled: true,
            animationType: "move",
            symbolType: "basic",
            animationDelayStart: 300,
            animationDelayStop: 300,
            matrixColumn: 5,
            matrixRow: 3,
            symbolSize: {
                width: 150,
                height: 150,
            },
            touchZone: {
                width: 150,
                height: 150,
                reels: ["right", "right", "right", "left", "left"],
                table: "table.png",
                //numbers: "page_2_numbers.png",
                numbers: "3x4x5x.png",
                //"font": "font_factors-export",
                font: "font_wintable",
                factors: 4,
            },
            shift: 55,
            baseMatrix: {
                x: [160, 400, 640, 880, 1120], //[210, 430, 640, 860, 1080],
                y: [140, 140, 140, 140, 140], //[150, 360, 500],
            },
            staticSymbols: {},
        },
        symbols: [
            // {
            //     "name" : "symbol_crystal_blue",
            //     "serverName" : "symbol_crystal_blue",
            //     "monsterName": "symbol_crystal_blue",
            //     "index" : 0,
            //     "type" : "normal",
            //     "textures" : {
            //         "main" : "crystal_blue"
            //     },
            //     "textureSufix" : ".png",
            //     "animations" : [
            //     ],
            //     "layerId" : 0,
            //     "scale" : 1,
            //     "anims": {
            //         "win": {
            //             "name": "symbol_crystal_blue_000",
            //             "start": 0,
            //             "end": 17
            //         }
            //     }
            // },
        ],

        flash: {},
        info: {
            enabled: false,
            pages: 2,
        },
        c: {},
        s: {},
        h: {
            sprites: [
                gamePath + "assets/img/symbols/symbols.json",
                gamePath + "assets/img/reels/sea/sea_reels_menu_full_atlas.json",
                gamePath + "assets/img/reels/storm/storm.json",
                gamePath + "assets/img/reels/foreground.json",
                gamePath + "assets/img/fonts/font_wintable.xml",
                gamePath + "assets/img/fonts/font_win-export.xml",
                gamePath + "assets/img/fonts/font_free_spins.xml",
                gamePath + "assets/img/symbols/symbol_J/symbol_J.json",
                gamePath + "assets/img/symbols/symbol_Q/symbol_Q.json",
                gamePath + "assets/img/symbols/symbol_K/symbol_K.json",
                gamePath + "assets/img/symbols/symbol_A/symbol_A.json",
                gamePath + "assets/img/symbols/symbol_Bracelet/symbol_Bracelet.json",
                gamePath + "assets/img/symbols/symbol_Shield/symbol_Shield.json",
                gamePath + "assets/img/symbols/symbol_Axe/symbol_Axe.json",
                gamePath + "assets/img/symbols/symbol_Helmet/symbol_Helmet.json",                
                gamePath + "assets/img/symbols/symbol_Scatter/symbol_Scatter.json",
                gamePath + "assets/img/symbols/symbol_Viking/symbol_Viking.json",
                gamePath + "assets/img/symbols/symbol_Woman/symbol_Woman.json",
                gamePath + "assets/img/symbols/symbol_Wild/symbol_Wild.json",
                gamePath + "assets/img/symbols/dust/dust.json",
                gamePath + "assets/img/symbols/particles/particles.json",
                gamePath + "assets/img/symbols/fire_effects/fire_background_atlas.json",
                gamePath + "assets/img/symbols/fire_effects/arrow_atlas.json",
                gamePath + "assets/img/symbols/fire_effects/fire_ring_atlas.json",
                gamePath + "assets/img/multiplier/multi_atlas.json",
                gamePath + "assets/img/freespins/fire_rope_atlas.json",
                gamePath + "assets/img/freespins/fire_fs_bg_atlas.json",
                gamePath + "assets/img/freespins/fire_fs_atlas.json",
                gamePath + "assets/img/bigwin/bw_fire_atlas.json",
            ],
            assets: [
                // {
                //     "name": "top",
                //     "url": gamePath + "assets/top.png",
                //     "type": "Image"
                // }

                {
                    name: "background",
                    url: gamePath + "assets/img/reels/background.jpg",//.png",                  
                    type: "Image",
                },                
                {
                    name: "win_background",
                    url: gamePath + "assets/img/reels/win_background.png",
                    type: "Image",
                },                
                {
                    "name" : "info_background",
                    // "url"  : gamePath + "info_background.png",
                    url: gamePath + "assets/img/wintable/background.png",
                    "type" : "Image"
                },
                {
                    name: "2x3x4x5x.png",
                    url: gamePath + "assets/img/wintable/2x3x4x5x.png",
                    type: "Image",
                },
                {
                    name: "3x4x5x.png",
                    url: gamePath + "assets/img/wintable/3x4x5x.png",
                    type: "Image",
                },
                {
                    name: "table.png",
                    url: gamePath + "assets/img/wintable/table.png",
                    type: "Image",
                },
                {
                    name: "table4lines.png",
                    url: gamePath + "assets/img/wintable/table4lines.png",
                    type: "Image",
                },
                {
                    name: "table3lines.png",
                    url: gamePath + "assets/img/wintable/table3lines.png",
                    type: "Image",
                },
                {
                    name: "winlines.png",
                    url: gamePath + "assets/img/wintable/winlines.png",
                    type: "image",
                },
                {
                    name: "10x_free_spins.png",
                    url: gamePath + "assets/img/wintable/10x_free_spins.png",
                    type: "image",
                },
                {
                    name: "free-spins_background.png",
                    url: gamePath + "assets/img/freespins/free-spins_background.png",
                    type: "image",
                },
                {
                    name: "free-spins_text.png",
                    url: gamePath + "assets/img/freespins/text.png",
                    type: "Image",
                },
                {
                    name: "winText.png",
                    url: gamePath + "assets/img/freespins/win_text.png",
                    type: "Image",
                },
                {
                    name: "bw_table.png",
                    url: gamePath + "assets/img/bigwin/bw_table.png",
                    type: "Image",
                },
                {
                    name: "bigwin.png",
                    url: gamePath + "assets/img/bigwin/bigwin.png",
                    type: "Image",
                },
                {
                    name: "megawin.png",
                    url: gamePath + "assets/img/bigwin/megawin.png",
                    type: "Image",
                },
                {
                    name: "supermegawin.png",
                    url: gamePath + "assets/img/bigwin/supermegawin.png",
                    type: "Image",
                },
/*                -- shine images are in symbols.png atlas
                {
                    name: "shine_scatter.png",//ship.png",
                    url: gamePath + "assets/img/symbols/shine_ship.png",
                    type: "Image",
                },
                {
                    name: "shine_viking.png",
                    url: gamePath + "assets/img/symbols/shine_viking.png",
                    type: "Image",
                },
                {
                    name: "shine_woman.png",
                    url: gamePath + "assets/img/symbols/shine_woman.png",
                    type: "Image",
                },
                {
                    name: "shine_wild.png",
                    url: gamePath + "assets/img/symbols/shine_wild.png",
                    type: "Image",
                },
*/                
                /*                
                                { // is this needed ?!?!?
                                    name: "lightningLight.png",
                                    url: gamePath + "asset/img/bigwin/light.png",
                                    type: "Image",
                                },
                */
                /*                {
                    name: 'wintable_2.png',
                    url: gamePath + 'assets/img/info/wintable_2.png',
                    type: 'Image',
                },
*/
            ],
        },
        lines: [],
        grelems: [],
    },
};

export default gameset;
